module.exports = __webpack_public_path__ + "media/country_flags/zw-5cd06487.png";